
import { toRefs, onMounted } from "vue";
export default {
    props: {
        data: {
            default: {},
        },
    },
    setup(props: any) {
        let { data } = toRefs(props);

        onMounted(() => {
        });

        return {
            data,
        };
    },
};
